module.exports = __webpack_public_path__ + "img/change-card-1.svg";